import React from 'react'
import PropTypes from 'prop-types'
import { Progress } from '@adc/ui-core'
import classnames from 'classnames/bind'
import styles from './styles.scss'
const cx = classnames.bind(styles)

const ProgressBar = props => {
  const { percent, indicating = true, label = '' } = props

  return (
    <div className={cx('progress-bar-container')}>
      <Progress
        className={cx('progress-bar')}
        percent={percent}
        label={label}
        color='green'
        indicating={indicating}
      />
    </div>
  )
}

ProgressBar.propTypes = {
  percent: PropTypes.number.isRequired,
  indicating: PropTypes.bool,
  label: PropTypes.string,
}

export default ProgressBar
